import LazyLoad from "vanilla-lazyload";
// import { alignQuickShop } from "../partials/list/productItem";

var lazyLoadInstance = null;
var loadImages = function loadImages() {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  } else {
    var hasProductList = $(".js-productItem").length > 0;
    lazyLoadInstance = new LazyLoad({
      threshold: 500,
      elements_selector: ".js-lazy",
      callback_error: function callback_error(el) {
        el.src = window.sitewide.imagePlaceholder || '';
        el.removeAttribute('data-srcset');
        el.removeAttribute('srcset');
      },
      callback_loaded: function callback_loaded(el) {
        $(window).trigger("imageLoaded.lazyload");
        // if (hasProductList && $(el).closest(".js-productItem").length > 0)
        //   alignQuickShop();
      }
    });
  }
};
export default loadImages;


// WEBPACK FOOTER //
// ./scripts/util/loadImages.js